import faker from 'faker'
import moment from 'moment'
import hres4axLabels from 'assets/labels/hres4ax'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres4axLabels
    }
  },
  index () {
    let mockRows = []
    let status = [ 'Pending', 'Approving', 'Rejected', 'Approved' ]
    let staappr = { 'Pending': 'P', 'Approving': 'A', 'Rejected': 'N', 'Approved': 'Y' }
    const mockTotal = 15
    for (var i = 1; i <= mockTotal; i++) {
      let dteReg = moment(faker.date.between('2015-01-01', faker.date.recent())).format('DD/MM/YYYY')
      let mockStatus = faker.random.arrayElement(status)
      mockRows.push({
        id: i,
        codcompy: faker.lorem.word().substr(0, 3),
        desc_compy: faker.lorem.word(),
        codlinef: faker.lorem.word().substr(0, 4),
        desc_linef: faker.commerce.department(),
        dteeffec: dteReg,
        dteuse: mockStatus === 'Approved' && moment(faker.date.between(moment(dteReg, 'DD/MM/YYYY').format('YYYY-MM-DD'), faker.date.recent())).format('DD/MM/YYYY') || '',
        codappr: faker.lorem.word().substr(0, 8),
        desc_appr: faker.lorem.word(),
        staappr: staappr[mockStatus],
        status: mockStatus
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  currentNumseq () {
    return 1
  },
  create () {
    let mockDetail = {
      codempid: faker.lorem.word(),
      numseq: faker.random.number().toString().substr(0, 1),
      dtereq: moment().format('DD/MM/YYYY'),
      staappr: '',
      routeno: '',
      dtestrt: moment().format('DD/MM/YYYY'),
      dteend: moment().format('DD/MM/YYYY'),
      timbstr: '',
      timbend: '',
      timdstr: '',
      timdend: '',
      timastr: '',
      timaend: '',
      codrem: '',
      remark: ''
    }

    return mockDetail
  },
  detail () {
    return require('./mockDetail')
  },
  popup1 () {
    let mockPopup1Detail = {
      codcompy1: faker.lorem.word(),
      descodcompy1: faker.lorem.words(),
      codlinef1: faker.lorem.word(),
      deslinef1: faker.lorem.words(),
      dteeffec: moment().format('DD/MM/YYYY'),
      codcompp: faker.lorem.words(),
      codpospr: faker.lorem.words()
    }

    let mockPopup1Tab1Total = 5
    let mockPopup1Tab1Rows = []
    for (let i = 1; i <= mockPopup1Tab1Total; i++) {
      mockPopup1Tab1Rows.push({
        codempid: faker.random.number().toString().substr(0, 1),
        desc_codempid: faker.name.findName(),
        desc_codpos: faker.name.jobDescriptor(),
        numlvl: faker.random.number().toString().substr(0, 1),
        dteempmt: moment().format('DD/MM/YYYY'),
        typemp: faker.lorem.word()
      })
    }

    let mockPopup1Tab2Total = 5
    let mockPopup1Tab2Rows = []
    for (let i = 1; i <= mockPopup1Tab2Total; i++) {
      mockPopup1Tab2Rows.push({
        odempid: faker.random.number().toString().substr(0, 1),
        desc_codempid: faker.name.findName(),
        desc_codcomp: faker.company.companyName(),
        desc_codpos: faker.name.jobDescriptor(),
        numlvl: faker.random.number().toString().substr(0, 1),
        dteempmt: moment().format('DD/MM/YYYY')
      })
    }

    let mockPopup1Tab3Total = 5
    let mockPopup1Tab3Rows = []
    for (let i = 1; i <= mockPopup1Tab3Total; i++) {
      mockPopup1Tab3Rows.push({
        odempid: i,
        desc_codempid: faker.name.findName(),
        desc_codcomp: faker.company.companyName(),
        desc_codpos: faker.name.jobDescriptor(),
        numlvl: faker.random.number().toString().substr(0, 1),
        dteempmt: moment().format('DD/MM/YYYY')
      })
    }
    return {
      detail: mockPopup1Detail,
      tab1: {
        total: mockPopup1Tab1Total,
        rows: mockPopup1Tab1Rows
      },
      tab2: {
        total: mockPopup1Tab2Total,
        rows: mockPopup1Tab2Rows
      },
      tab3: {
        total: mockPopup1Tab3Total,
        rows: mockPopup1Tab3Rows
      }
    }
  },
  dropdowns () {
    let mockCodremEn = {}
    let mockCodremTh = {}
    const mockTotal = Math.floor(Math.random() * 15) + 10
    for (var i = 1; i <= mockTotal; i++) {
      mockCodremEn[faker.lorem.word()] = faker.lorem.word()
      mockCodremTh[faker.lorem.word()] = faker.lorem.word()
    }
    return {
      codrem: {
        en: mockCodremEn,
        th: mockCodremTh
      }
    }
  },
  popup2 () {
    let mockPopup2Detail = {
      codcompy1: faker.lorem.word(),
      descodcompy1: faker.lorem.words(),
      codlinef1: faker.lorem.word(),
      deslinef1: faker.lorem.words(),
      dteeffec: moment().format('DD/MM/YYYY'),
      codcompp: faker.lorem.words(),
      codpospr: faker.lorem.words()
    }

    let mockPopup2DetailTab1 = {
      codcompy1: faker.lorem.word(),
      descodcompy1: faker.lorem.words(),
      codlinef1: faker.lorem.word(),
      deslinef1: faker.lorem.words(),
      dteeffec: moment().format('DD/MM/YYYY'),
      codcompp: faker.lorem.words(),
      codpospr: faker.lorem.words()
    }

    let mockPopup2Tab2Total = 5
    let mockPopup2Tab2Rows = []
    for (let i = 1; i <= mockPopup2Tab2Total; i++) {
      mockPopup2Tab2Rows.push({
        kpino: faker.random.number().toString().substr(0, 1),
        kpiitem: faker.lorem.words(),
        target: faker.lorem.words()
      })
    }

    let mockPopup2Tab3Total = 5
    let mockPopup2Tab3Rows = []
    for (let i = 1; i <= mockPopup2Tab3Total; i++) {
      mockPopup2Tab3Rows.push({
        codtencyd: faker.lorem.word(),
        desc_codtencyd: faker.lorem.words(),
        codskill: faker.lorem.word(),
        desc_codskill: faker.lorem.words(),
        fscore: faker.random.number().toString().substr(0, 2),
        score: faker.random.number().toString().substr(0, 2)
      })
    }
    return {
      detail: mockPopup2Detail,
      tab1: mockPopup2DetailTab1,
      tab2: {
        total: mockPopup2Tab2Total,
        rows: mockPopup2Tab2Rows
      },
      tab3: {
        total: mockPopup2Tab3Total,
        rows: mockPopup2Tab3Rows
      }
    }
  },
  save () {
    return labels.mockPostMessage
  },
  cancel () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres4ax/mocker.js